/* connections.js */

"use strict";

// const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const {
    Control: {
        Action: {Button},
        // Unused imports commented out
        // Boolean: {InputCheckbox},
        // Textfield: {InputText},
        OptionSelection: {
            Single: {
                // InputRadio,
                ComboBox,
            },
        },
    },
} = uiCore;

class ConnectionsTab {
    constructor(ctx) {
        ctx._serviceConnectionSelection = new ComboBox({
            darkTheme: true,
            required: false,
            disabled: false,
            allowClear: true,
            value: "",
        });

        ctx._xdTestButton = new Button({
            label: "Test Claroty xDome Connection",
            darkTheme: true,
            disabled: false,
        });

        ctx._addNewConnectionButton = new Button({
            label: "Add Connection",
            darkTheme: true,
            disabled: false,
            class: "add-connection-button",
        });

        ctx._noConnectionEl = document.createElement("div");
        ctx._noConnectionEl.classList.add("no-cmdb-connection");
        ctx._connectionsLinkEl = document.createElement("a");
        ctx._connectionsLinkEl.classList.add("connections-link", "hyperlink");
        ctx._connectionsLinkEl.innerHTML = "Connections View";
        ctx._noConnectionEl.innerHTML =
            "No Claroty xDome connections available. Please create one in the&nbsp;";
        ctx._noConnectionEl.appendChild(ctx._connectionsLinkEl);
        const periodEl = document.createElement("span");
        periodEl.innerText = ".";
        ctx._noConnectionEl.appendChild(periodEl);

        ctx._handleConnectionsLinkClick = ctx._handleConnectionsLinkClick.bind(ctx);
    }

    /* RENDERER : START */

    _createConnectionsTabContent(ctx) {
        const _tabContentContainer = document.createElement("div");
        _tabContentContainer.classList.add("content-container");
        const _tabMainContent = document.createElement("div");
        _tabMainContent.classList.add("content-main", "hidden");
        const serviceConnectionSelectionContainer = ctx._uiUtils.wrapElement(
            ctx._serviceConnectionSelection.renderer.getRootElement(),
            "Connection",
            "input-container"
        );
        _tabMainContent.appendChild(serviceConnectionSelectionContainer);

        _tabMainContent.appendChild(ctx._addNewConnectionButton._renderer._rootElem);
        _tabMainContent.appendChild(ctx._xdTestButton._renderer._rootElem);

        _tabContentContainer.appendChild(_tabMainContent);
        _tabContentContainer.appendChild(ctx._noConnectionEl);
        ctx._xdConnectionsContent = _tabMainContent;
        return _tabContentContainer;
    }

    /* RENDERER : END */

    /* EVENT LISTENERS REGISTRATIONS : START */
    _registerConnectionTabEvents(ctx) {
        // Note: _enablexDome is used but not defined in the visible code
        ctx._enablexDome.on("UserValue", (ctx._enableChange = ctx._enableChange.bind(ctx)));
        ctx._xdTestButton.on(
            "UserClick",
            (ctx._testSSConnectivityAction = ctx._testSSConnectivityAction.bind(ctx))
        );

        ctx._serviceConnectionSelection.on("UserValue", ctx._onServiceConnectionChange);
        ctx._addNewConnectionButton.on(
            "UserClick",
            (ctx._newConnectionAction = ctx._newConnectionAction.bind(ctx))
        );
        ctx._connectionsLinkEl.addEventListener("click", ctx._handleConnectionsLinkClick);
    }

    _unregisterConnectionTabEvents(ctx) {
        ctx._enablexDome.removeListener("UserValue", ctx._enableChange);
        ctx._xdTestButton.removeListener("UserClick", ctx._testSSConnectivityAction);

        ctx._serviceConnectionSelection.removeListener("UserValue", ctx._onServiceConnectionChange);
        ctx._addNewConnectionButton.removeListener("UserClick", ctx._newConnectionAction);
        ctx._connectionsLinkEl.removeEventListener("click", ctx._handleConnectionsLinkClick);
    }

    /* EVENT LISTENERS REGISTRATIONS : END */

    /* HELPERS : START */
    _validateConnectionTab(ctx) {
        if (!ctx._model._xdDataSyncConfigEntity.getServiceConnectionId()) {
            return false;
        }
        return true;
    }

    _getConnectionId(ctx) {
        const serviceConnectionId = ctx._model._xdDataSyncConfigEntity.getServiceConnectionId();
        return serviceConnectionId;
    }

    _getConnectionOptions(ctx) {
        const connectionOptions = ctx._model._serviceConnectionEntities.map((entity) => {
            return {
                label: entity.name,
                value: entity.id,
            };
        });
        return connectionOptions;
    }

    _getPristinePropertiesConnectionId(ctx) {
        const serviceConnectionId =
            ctx._model._xdDataSyncConfigEntity.pristineProperties.serviceConnectionId;
        return serviceConnectionId;
    }

    _setConnectionValue(ctx) {
        const serviceConnectionId = ctx._serviceConnectionSelection.getValue();
        ctx._model._xdDataSyncConfigEntity.setServiceConnectionId(serviceConnectionId);
    }

    _resetConnectionValue(ctx) {
        const serviceConnectionId = this._getPristinePropertiesConnectionId(ctx);
        ctx._serviceConnectionSelection.setValue(serviceConnectionId);
    }

    /* HELPERS : END */
}

module.exports = ConnectionsTab;
